import type { GalleryPopularityEvent } from "@/lib/gallery/popularity";
import { logger } from "@/utils/logger";

interface GalleryEngagementPayload {
  ticketId: string;
  eventName: GalleryPopularityEvent;
  timeSpentSeconds?: number;
  occurredAt?: string;
}

const ENDPOINT = "/api/gallery/engagement";

export function recordGalleryEngagement(
  payload: GalleryEngagementPayload,
  options?: { beacon?: boolean }
): void {
  if (typeof window === "undefined") return;

  const body = JSON.stringify({
    ...payload,
    occurredAt: payload.occurredAt ?? new Date().toISOString(),
  });

  if (options?.beacon && typeof navigator !== "undefined") {
    try {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(ENDPOINT, blob)) {
        return;
      }
    } catch {
      // Fall through to fetch keepalive.
    }
  }

  fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    credentials: "include",
    keepalive: true,
  }).catch(error => {
    logger.debug("Failed to send gallery engagement event", {
      component: "galleryEngagement",
      metadata: {
        ticketId: payload.ticketId,
        eventName: payload.eventName,
        error: error instanceof Error ? error.message : String(error),
      },
    });
  });
}
